(function () {
  'use strict';

  angular.module('wsLrs.directives').
  /**
   * This directive allows for a "click-to-edit" text area. There's no specific styling put in here,
   * so you want to contain this directive inside some sort of other text formatting element.
   *
   * @param name The name of the underlying field to update.
   *             Will be used only for the event that is raised.
   * @param value The value to display and subsequently edit.
   * @param inputClass Any additional CSS classes to apply to the input element.
   */
  directive('wsEditableText', [function () {
    return {
      restrict: 'E',
      scope: {
        name: '@',
        value: '=',
        emptyDisplay: '@',
        inputClass: '@'
      },
      template: '<span ng-bind="value || emptyDisplay" style="cursor: pointer;"></span>' + '<input type="text" class="form-control ng-hide {{inputClass}}" ng-model="value"/>',
      link: function link(scope, element) {
        scope.emptyDisplay = scope.emptyDisplay || '--';
        var title = element.find("span").eq(0),
          input = element.find("input").eq(0);

        // Start editing mode when they click the card title
        title.on('click', function () {
          scope.initialValue = angular.copy(scope.value);
          var height = element.height() * 1.0,
            width = Math.max(element.width() * 1.0, 80);
          title.toggleClass("ng-hide");
          input.css({
            height: height,
            width: width,
            display: 'inline'
          }).toggleClass("ng-hide").focus().select();
        });

        // End editing mode when they click away
        input.on('blur', function () {
          if (scope.value !== scope.initialValue) {
            scope.$emit(scope.name + '-changed', scope.initialValue, scope.value);
          }
          title.toggleClass("ng-hide");
          input.toggleClass("ng-hide");
        });

        // Also end editing mode when they hit enter
        input.on('keyup', function (evt) {
          if (evt.keyCode === 13) {
            input.blur();
          }
        });
      }
    };
  }]);
})();
